// „Wie diktiere ich?“ – ein kleiner Link unter einem Textfeld, der den einen
// passenden Satz für dieses Gerät aufklappt (diktat.ts). Dezent und ohne
// Erklär-Absatz: Gernot, 22.10.2026 – „nicht mit 100.000 Hinweisen, es soll
// klar sein, auch für jemanden, dem es nie erklärt wurde“.

import { useState } from "react";
import { diktatAnleitung } from "./diktat.ts";
import { Ikon } from "./Ikon.tsx";

export function DiktatHilfe() {
  const [offen, setOffen] = useState(false);
  const satz = diktatAnleitung();
  if (!satz) return null;
  return (
    <div className="diktat-hilfe">
      <button type="button" className="diktat-hilfe-knopf" aria-expanded={offen} onClick={() => setOffen(!offen)}>
        <Ikon name="mikro" groesse="k" /> Wie diktiere ich?
      </button>
      {offen && <p className="diktat-hilfe-satz">{satz}</p>}
    </div>
  );
}
